import { Clock } from '@common_components/clock/clock.component';
import { AppLink } from '@common_components/link/app_link.component';
import { APP_KEY } from 'constants/app.constants';
import React, { ReactNode } from 'react';
import Bar from './bar.component';

interface FooterProps {
  children?: ReactNode;
  hide?: boolean;
}

const Footer: React.FC<FooterProps> = ( { children, hide = false } ) => {
  return (
    <div className={`px-6 bottom-0 w-full pl-20 backdrop-blur-sm z-10 ${hide ? 'hidden' : 'fixed'}`}>
      <Bar/>
      <div className='flex justify-between mt-1 mb-3'>
        <AppLink appKey={APP_KEY} />

        <div className="mx-4 h-full max-w-[calc(100%-16rem)] flex-wrap">
          {children}
        </div>

        <div className='font-title text-right w-32 flex-center'>
          <Clock />
        </div>
      </div>
    </div>
  );
};

export default Footer;
